<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M6.4 22q-.8 0-1.3-.6t-.6-1.3v-9.5q0-.9.6-1.4t1.3-.5h1v-2q0-2 1.3-3.3Q10 1.9 12 2q2 0 3.3 1.4 1.4 1.4 1.4 3.4v1.9h1q.7 0 1.2.5t.6 1.4V20q0 .8-.6 1.3t-1.3.6zm5.6-4.8q.8 0 1.3-.5t.6-1.4-.6-1.3-1.3-.6-1.3.6-.6 1.3.6 1.4 1.3.5M9.2 8.7h5.6v-2q0-1-.8-2-.8-.8-2-.8t-2 .8q-.8 1-.8 2z"
    />
  </svg>
</template>
